module.exports = __webpack_public_path__ + "static/the-hundredyear-marathon-fa3670a859dd3c5271de18ad03a844dc.jpg";